import React from "react";

interface Props {
  type: string; // 图标类名，如 "ficon-a-trash..." 或 "icon-images-3"
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const IconFont: React.FC<Props> = ({ type, className, style, onClick }) => {
  // 1. 根据前缀判断属于哪个库
  const isIconFont = type.startsWith('ficon-');
  const isIcomoon = type.startsWith('icon-');

  const fullClassName = [
    'g-icon',
    isIconFont ? 'iconfont' : '',
    type,
    className
  ].filter(Boolean).join(' ');

  return (
      <span
          className={fullClassName}
          style={{
            display: "inline-block",
            ...style,
          }}
          onClick={onClick}
      />
  );
};

export { IconFont };